<template>
  <div>
    <b-media
      no-body
    >
      <b-media-aside
        class="mr-2"
      >
        <b-avatar
          size="48"
          :variant="'light-'+color"
        >
          <feather-icon
            size="24"
            :icon="icon"
          />
        </b-avatar>
      </b-media-aside>
      <b-media-body class="my-auto">
        <h4 class="font-weight-bolder mb-0">
          <span v-if="prefix">{{ prefix }}</span>
          <span>
            {{ value | toNumber }}
          </span>
          <span v-if="suffix">{{ suffix }}</span>
        </h4>
        <b-card-text class="font-small-3 mb-0 text-nowrap">
          {{ title }}
        </b-card-text>
      </b-media-body>
    </b-media>
  </div>
</template>

<script>
import {
  BMedia, BMediaAside, BAvatar, BMediaBody, BCardText,
} from 'bootstrap-vue'

export default {
  name: 'FlatCard',
  components: {
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BCardText,
  },
  props: {
    color: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>
